import {
  useActionItem,
  ActionItemOperation as Operation,
} from '@workboard/action-item';

import { useModal } from '../../utils/useModal';
import { MirrorAiModal } from '../../MirrorAiModal';

export function useMirrorModal(aiId: string | null) {
  const { isPermitted, actionItem } = useActionItem(aiId);
  const canMirror = isPermitted(Operation.mirror);

  const { show: showMirrorAiModal } = useModal(MirrorAiModal, {
    aiId,
    title: actionItem?.typeAttributes?.label ?? 'action',
  });

  return [canMirror, showMirrorAiModal] as const;
}
